// LIBRARIES
import dayjs from "dayjs";

//REDUX
import { createSlice } from "@reduxjs/toolkit";

//MISC
import { getAllInvoices } from "api/invoicesApi";
import { IInvoicesApiParams, InvoicesTableData } from "models/interfaces";

export interface ISessionInitialState {
  isLoading: boolean;
  errorMessage: string;
  invoicesTotalPages: number;
  invoicesTableData: InvoicesTableData[];
  invoicesFilters: IInvoicesApiParams;
  selectedInvoicesReportType: string;
}

const initialState: ISessionInitialState = {
  isLoading: false,
  errorMessage: "",
  invoicesTotalPages: 0,
  invoicesTableData: [],
  invoicesFilters: {
    userFullName: {
      usernameOrPhoneNumber: "",
    },
    startDate: "",
    endDate: "",
    page: "",
  },
  selectedInvoicesReportType: "",
};

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    toggleInvoicesFiltersUserFullNameState: (state, action) => {
      state.invoicesFilters.userFullName = action.payload;
    },
    toggleInvoicesFiltersStartDateState: (state, action) => {
      state.invoicesFilters.startDate = action.payload;
    },
    toggleInvoicesFiltersEndDateState: (state, action) => {
      state.invoicesFilters.endDate = action.payload;
    },
    toggleInvoicesFiltersPageState: (state, action) => {
      state.invoicesFilters.page = action.payload;
    },
    toggleClearInvoicesFiltersState: (state) => {
      state.invoicesFilters = {
        userFullName: {
          usernameOrPhoneNumber: "",
        },
        startDate: "",
        endDate: "",
        page: "",
      };
    },
    toggleClearInvoicesTableData: (state) => {
      state.invoicesTableData = null;
    },
    toggleSelectedInvoicesReportType: (state, action) => {
      state.selectedInvoicesReportType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllInvoices.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getAllInvoices.fulfilled, (state, action) => {
      state.isLoading = false;
      let data = action.payload.content;
      let initialData = Array.from({ length: data.length }, () => ({
        fullName: "",
        creationDate: "",
        amount: "",
        isRefund: "",
      }));
      data.forEach((item, index) => {
        initialData[index] = {
          fullName: item.customer.user.fullName,
          creationDate: dayjs(item.creationDate).format("DD/MM/YYYY"),
          amount: item.amount ? `${item.amount / 100} RON` : "0 RON",
          isRefund: item.isRefund === false ? "No" : "Yes",
        };
      });
      state.invoicesTableData = initialData;
      state.invoicesTotalPages = action.payload.totalPages;
    });
    builder.addCase(getAllInvoices.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
  },
});

//eslint-disable-next-line
export const {
  toggleInvoicesFiltersUserFullNameState,
  toggleInvoicesFiltersStartDateState,
  toggleInvoicesFiltersEndDateState,
  toggleInvoicesFiltersPageState,
  toggleClearInvoicesFiltersState,
  toggleClearInvoicesTableData,
  toggleSelectedInvoicesReportType,
} = invoicesSlice.actions;

export const invoicesData = (state) => state.invoices.invoicesTableData;
export const invoicesTotalPages = (state) => state.invoices.invoicesTotalPages;
export const invoicesFilters = (state) => state.invoices.invoicesFilters;
export const selectedInvoicesReportTypes = (state) =>
  state.invoices.selectedInvoicesReportType;

export default invoicesSlice.reducer;
